<template>
    <div :class="{'popup': true, 'active': isActive}">
        <div class="popup__inner">
            <div class="popup__certification">
                <div class="popup__tit">
                    <h2>정보등록</h2>
                    <button type="button" class="popup__close" @click="hidePopup"><img src="@/assets/resource/icon/close.svg" alt=""></button>
                </div>
                <div class="popup__body">
                    <p class="text-right">
                        <span class="c-red">*</span> 표시는 필수 입력 항목입니다.
                    </p>
                    <div class="popup-baby-info top">
                        <ul class="popup-baby-info__list">
                            <li class="popup-baby-info__item"> 
                                <h4 class="title03">
                                    <span class="c-red">*</span> 
                                    엄마이름
                                </h4>
                                <input type="text" v-model="params.momName">
                            </li>
                            <li class="popup-baby-info__item">
                                <h4 class="title03">
                                    아빠이름
                                </h4>
                                <input type="text" v-model="params.dadName">
                            </li>
                            <li class="popup-baby-info__item">
                                <h4 class="title03">
                                    <span class="c-red">*</span> 
                                    출산예정일
                                </h4>
                                <VueDatePicker
                                    v-model="params.expectedDt"
                                    locale="ko"
                                    :format="formatDate"
                                    :enable-time-picker="false"
                                    week-start="0"
                                    position="left"
                                    placeholder="날짜를 선택하세요."
                                    auto-apply
                                />
                            </li>
                        </ul>
                    </div>
                    <div class="popup-baby-info bottom">
                        <ul class="popup-baby-info__list">
                            <li class="popup-baby-info__item"> 
                                <h4 class="title03">
                                    <span class="c-red">*</span> 
                                    태명
                                </h4>
                                <input type="text" v-model="params.baby1">
                            </li>
                            <li class="popup-baby-info__item">
                                <h4 class="title03">
                                    <span class="c-red">*</span> 
                                    아기성별
                                </h4>
                                <div class="popup-baby-info__btn-wrap">
                                    <a href="javascript:;" :class="{'popup-baby-info__btn c-gray': true, 'active': params.baby1Gender == 'N'}" @click="setGender(1, 'N')">미정</a>
                                    <a href="javascript:;" :class="{'popup-baby-info__btn c-sub': true, 'active': params.baby1Gender == 'M'}" @click="setGender(1, 'M')">남자</a>
                                    <a href="javascript:;" :class="{'popup-baby-info__btn c-main': true, 'active': params.baby1Gender == 'F'}" @click="setGender(1, 'F')">여자</a>
                                </div>
                            </li>
                        </ul>
                        <ul class="popup-baby-info__list plus" v-if="count > 1">
                            <li class="popup-baby-info__item"> 
                                <h4 class="title03">
                                    <span class="c-red">*</span> 
                                    태명
                                </h4>
                                <input type="text" v-model="params.baby2">
                            </li>
                            <li class="popup-baby-info__item">
                                <h4 class="title03">
                                    <span class="c-red">*</span> 
                                    아기성별
                                </h4>
                                <div class="popup-baby-info__btn-wrap">
                                    <a href="javascript:;" :class="{'popup-baby-info__btn c-gray': true, 'active': params.baby2Gender == 'N'}" @click="setGender(2, 'N')">미정</a>
                                    <a href="javascript:;" :class="{'popup-baby-info__btn c-sub': true, 'active': params.baby2Gender == 'M'}" @click="setGender(2, 'M')">남자</a>
                                    <a href="javascript:;" :class="{'popup-baby-info__btn c-main': true, 'active': params.baby2Gender == 'F'}" @click="setGender(2, 'F')">여자</a>
                                </div>
                            </li>
                            <li class="popup-baby-info__close">
                                <a href="javascript:;" @click="minusCount"></a>
                            </li>
                        </ul>
                        <ul class="popup-baby-info__list plus" v-if="count > 2">
                            <li class="popup-baby-info__item"> 
                                <h4 class="title03">
                                    <span class="c-red">*</span> 
                                    태명
                                </h4>
                                <input type="text" v-model="params.baby3">
                            </li>
                            <li class="popup-baby-info__item">
                                <h4 class="title03">
                                    <span class="c-red">*</span> 
                                    아기성별
                                </h4>
                                <div class="popup-baby-info__btn-wrap">
                                    <a href="javascript:;" :class="{'popup-baby-info__btn c-gray': true, 'active': params.baby3Gender == 'N'}" @click="setGender(3, 'N')">미정</a>
                                    <a href="javascript:;" :class="{'popup-baby-info__btn c-sub': true, 'active': params.baby3Gender == 'M'}" @click="setGender(3, 'M')">남자</a>
                                    <a href="javascript:;" :class="{'popup-baby-info__btn c-main': true, 'active': params.baby3Gender == 'F'}" @click="setGender(3, 'F')">여자</a>
                                </div>
                            </li>
                            <li class="popup-baby-info__close">
                                <a href="javascript:;" @click="minusCount"></a>
                            </li>
                        </ul>
                        <ul class="popup-baby-info__list plus" v-if="count > 3">
                            <li class="popup-baby-info__item"> 
                                <h4 class="title03">
                                    <span class="c-red">*</span> 
                                    태명
                                </h4>
                                <input type="text" v-model="params.baby4">
                            </li>
                            <li class="popup-baby-info__item">
                                <h4 class="title03">
                                    <span class="c-red">*</span> 
                                    아기성별
                                </h4>
                                <div class="popup-baby-info__btn-wrap">
                                    <a href="javascript:;" :class="{'popup-baby-info__btn c-gray': true, 'active': params.baby4Gender == 'N'}" @click="setGender(4, 'N')">미정</a>
                                    <a href="javascript:;" :class="{'popup-baby-info__btn c-sub': true, 'active': params.baby4Gender == 'M'}" @click="setGender(4, 'M')">남자</a>
                                    <a href="javascript:;" :class="{'popup-baby-info__btn c-main': true, 'active': params.baby4Gender == 'F'}" @click="setGender(4, 'F')">여자</a>
                                </div>
                            </li>
                            <li class="popup-baby-info__close">
                                <a href="javascript:;" @click="minusCount"></a>
                            </li>
                        </ul>
                        <ul class="popup-baby-info__list plus" v-if="count > 4">
                            <li class="popup-baby-info__item"> 
                                <h4 class="title03">
                                    <span class="c-red">*</span> 
                                    태명
                                </h4>
                                <input type="text" v-model="params.baby5">
                            </li>
                            <li class="popup-baby-info__item">
                                <h4 class="title03">
                                    <span class="c-red">*</span> 
                                    아기성별
                                </h4>
                                <div class="popup-baby-info__btn-wrap">
                                    <a href="javascript:;" :class="{'popup-baby-info__btn c-gray': true, 'active': params.baby5Gender == 'N'}" @click="setGender(5, 'N')">미정</a>
                                    <a href="javascript:;" :class="{'popup-baby-info__btn c-sub': true, 'active': params.baby5Gender == 'M'}" @click="setGender(5, 'M')">남자</a>
                                    <a href="javascript:;" :class="{'popup-baby-info__btn c-main': true, 'active': params.baby5Gender == 'F'}" @click="setGender(5, 'F')">여자</a>
                                </div>
                            </li>
                            <li class="popup-baby-info__close">
                                <a href="javascript:;" @click="minusCount"></a>
                            </li>
                        </ul>
                        <div class="">
                            <a href="javascript:;" class="popup-baby-info--plus" @click="plusCount">
                                쌍둥이 추가
                            </a>
                            <p class="c-red">최대 다섯 쌍둥이까지 추가할 수 있어요</p>
                        </div>
                    </div>

                    <div class="botton-wrap">
                        <a href="javascript:;" class="sub-button c-main" @click="hidePopup">취소</a>
                        <a href="javascript:;" class="main-button c-main" @click="insertFamily">등록</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ul class="baby-notebook">
        <li class="baby-notebook__box">
            <div class="baby-notebook__box__top">
                <h3 class="title02" v-if="familyList.length > 0">{{$commonUtils.dateToStr(new Date(familyList[0].expectedDt), '.')}}</h3>
                <div class="botton-wrap" v-if="familyList.length > 0">
                    <a href="javascript:;" class="main-button small c-main" @click="openPopup('m')">정보수정</a>
                    <a href="javascript:;" class="sub-button small c-gray" @click="deleteFamily">초기화</a>
                </div>
            </div>
            <div class="baby-notebook__box__body">
                <template v-if="familyList.length == 0">
                    <div class="data-none">
                        <img v-if="$store.state.hospStore.hostNm == '대동맥혈관병원'" src="/resource/icon/emphasis-warning.svg" class="" alt="">
                        <img v-else-if="$store.state.hospStore.hostNm == '뇌혈관병원'" src="/resource/icon/emphasis-warning-brain.svg" class="" alt="">
                        <img v-else-if="$store.state.hospStore.hostNm == '엄마아기병원'" src="/resource/icon/emphasis-warning-mom.svg" class="" alt="">
                        <p>엄마와 아이에 대한 정보를 등록해주세요.</p>
                        <!-- <a href="javascript:;" class="main-button small c-main" @click="openPopup('i')">정보등록</a> -->
                        <a href="javascript:;" class="sub-button small c-gray" @click="openPopup('i')">정보등록</a>
                    </div>
                </template>
                <ul class="scroll" v-else>
                    <template v-for="idx in 5" :key="idx">
                        <li v-if="familyList[0][`baby${idx}`]">
                            <h4 class="title03">태명</h4>
                            <p class="name">{{familyList[0][`baby${idx}`]}}<span :class="writeGenderClass(familyList[0][`baby${idx}Gender`])">{{writeGender(familyList[0][`baby${idx}Gender`])}}</span></p>
                        </li>
                    </template>
                    <li>
                        <h4 class="title03">엄마이름</h4>
                        <p class="name">{{familyList[0].momName}}</p>
                    </li>
                    <li v-if="familyList[0].dadName">
                        <h4 class="title03">아빠이름</h4>
                        <p class="name">{{familyList[0].dadName}}</p>
                    </li>
                </ul>
                <div class="show-mo">
                    <div class="botton-wrap">
                        <a href="javascript:;" class="" @click="openPopup('m')">정보수정</a>
                        <a href="javascript:;" class="" @click="deleteFamily">초기화</a>
                    </div>
                </div>
            </div>
        </li> 

        <li class="baby-notebook__box">
            <div class="baby-notebook__box__top">
                <h3 class="title02">
                    최근 검진결과
                </h3>
                <router-link to="/kr/mypage/babyNote/checkupRecord" class="total-search__header--link">자세히보기</router-link>
            </div>
            <div class="baby-notebook__box__body">
                <!-- 데이터가 없을때 -->
                <div class="data-none" v-if="rsvDetail.length == 0">
                    <img v-if="$store.state.hospStore.hostNm == '대동맥혈관병원'" src="/resource/icon/emphasis-warning.svg" class="" alt="">
                    <img v-else-if="$store.state.hospStore.hostNm == '뇌혈관병원'" src="/resource/icon/emphasis-warning-brain.svg" class="" alt="">
                    <img v-else-if="$store.state.hospStore.hostNm == '엄마아기병원'" src="/resource/icon/emphasis-warning-mom.svg" class="" alt="">
                    <p>최근 검진 내역이 없습니다.</p>
                </div>
                <template v-else>
                    <ul class="scroll">
                        <li>
                            <p class="info">
                                <strong>엄마</strong>의 신장은 <strong class="font-main">{{rsvDetail[0].HEIGHT}}cm</strong> 체중은 <strong class="font-main">{{rsvDetail[0].WEIGHT}}kg</strong> 이에요!
                            </p>
                        </li>
                    </ul>
                    <p class="baby-notebook__box__body--bottom-text">다음 검진 예정일 : {{rsvDetail[0].NEXT_MED_DT}}</p>
                </template>
            </div>
        </li> 

        <li class="baby-notebook__box d-day">
            <div class="baby-notebook__box__top">
                <template v-if="familyList.length > 0">
                    <h3 class="d-day--title">{{setDDay(familyList[0].expectedDt)}}</h3>
                    <span class="d-day--btn">{{getWeekDate(familyList[0].expectedDt)}}</span>
                </template>
                <template v-else>
                    <h3 class="d-day--title">D-0</h3>
                    <span class="d-day--btn">0주 0일차</span>
                </template>
            </div>
            <div class="baby-notebook__box__body">
                <template v-if="familyList.length > 0">
                    <div class="baby-notebook__d-day-img">
                        <img class="" :src="require(`@/assets/resource/img/baby-notebook__box-d-day--One${monthsRemaining(familyList[0].expectedDt)}.png`)" alt="" v-if="!familyList[0].baby2">
                        <img class="" :src="require(`@/assets/resource/img/baby-notebook__box-d-day--Twins${monthsRemaining(familyList[0].expectedDt)}.png`)" alt="" v-else>
                    </div>
                </template>
                <ul class="baby-notebook__d-day-list" v-if="familyList.length > 0">
                    <template v-for="idx in 5" :key="idx">
                        <li v-if="familyList[0][`baby${idx}`]">
                            {{familyList[0][`baby${idx}`]}}
                        </li>
                    </template>
                </ul>
            </div>
        </li> 
        <li class="baby-notebook__box">
            <div class="baby-notebook__box__top">
                <h3 class="title02">
                    산모 Diary 
                </h3>
            </div>
            <div class="baby-notebook__box__body">
                <ul class="baby-notebook__box__body__btn-wrap">
                    <router-link to="/kr/mypage/babyNote/babyDiary" class="baby-notebook__box__body__btn">
                        산모일기 작성
                    </router-link>
                    <router-link to="/kr/mypage/babyNote/checkupRecord" class="baby-notebook__box__body__btn">
                        검진기록
                    </router-link>
                    <router-link to="/kr/mypage/babyNote/birthRecord" class="baby-notebook__box__body__btn">
                        출산기록 작성
                    </router-link>
                </ul>
            </div>
        </li> 
    </ul>
</template>
<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

export default {
    components: {
        VueDatePicker,
    },
    data() {
        return {
            formatDate: 'yyyy-MM-dd', // 원하는 날짜 형식 설정

            isActive: false,
            mode: 'i',
            familyList: [],

            params: {
                expectedDt: null,
                baby1: '',
                baby1Gender: 'N'
            },
            count: 1,

            rsvDetail: '',
        };
    },
    methods: {
        getWeekDate(targetDateStr) {
            const targetDate = new Date(targetDateStr);

            const dateMinus280 = new Date(targetDate.getTime() - 280 * 24 * 60 * 60 * 1000);

            const currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0);

            // 날짜 차이 계산 (밀리초 단위로 차이 계산)
            const deltaMilliseconds = currentDate - dateMinus280;

            // 밀리초를 일수로 변환 (1일 = 24시간 * 60분 * 60초 * 1000밀리초)
            const deltaDays = Math.floor(deltaMilliseconds / (24 * 60 * 60 * 1000));

            const weeks = Math.floor(deltaDays / 7);
            const days = deltaDays % 7;

            return weeks + '주' + days + '일차'
        },
        monthsRemaining(targetDateStr) {
            const targetDate = new Date(targetDateStr);

            const dateMinus280 = new Date(targetDate.getTime() - 280 * 24 * 60 * 60 * 1000);

            const currentDate = new Date();

            let yearsDifference = currentDate.getFullYear() - dateMinus280.getFullYear();
            let monthsDifference = currentDate.getMonth() - dateMinus280.getMonth();

            if (monthsDifference < 0) {
                yearsDifference--;
                monthsDifference += 12;
            }

            const totalMonths = (yearsDifference * 12 + monthsDifference) + 1;

            return ('0' + totalMonths).slice(-2);
        },
        setDDay(date){
            const today = new Date()
            const diffTime = new Date(date) - today;

            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            return `D-${diffDays}`
        },
        writeGenderClass(gender){
            return gender == 'M' ? 'type01' : gender == 'F' ? 'type02' : 'type03'
        },
        writeGender(gender){
            return gender == 'M' ? '남자' : gender == 'F' ? '여자' : '미정'
        },
        plusCount(){
            this.count++
            if(this.count > 5){
                this.count = 5
                alert('최대 다섯 쌍둥이까지 추가할 수 있습니다.')
            }
            this.params[`baby${this.count}`] = ''
            this.params[`baby${this.count}Gender`] = 'N'
        },
        minusCount(){
            this.params[`baby${this.count}`] = ''
            this.params[`baby${this.count}Gender`] = ''
            this.count--
        },
        setGender(no, gender){
            this.params[`baby${no}Gender`] = gender
        },
        openPopup(mode){
            this.isActive = true
            this.mode = mode
        },
        hidePopup(){
            this.isActive = false
        },
        getFamily(){
            this.axios.get(this.api.mypage.familyList)
            .then((res) => {
                this.familyList = res.data.result.list
                if(this.familyList && this.familyList.length > 0){
                    for (let key in this.familyList[0]) {
                        if (this.familyList[0].hasOwnProperty(key)) {
                            let value = this.familyList[0][key]
                            if(key == 'expectedDt'){
                                value = new Date(value)
                            }
                            if(key == 'useYn' || key == 'createdDt'){
                                continue
                            }
                            this.params[key] = value
                        }
                    }
                }
            })
        },
        insertFamily(){
            if(!this.params.momName){
                alert('엄마이름을 입력해주세요.')
                return
            }
            if(!this.params.expectedDt){
                alert('출산예정일을 입력해주세요.')
                return
            }
            if(new Date(this.params.expectedDt) < new Date()){
                alert("출산예정일이 현재날짜보다 과거입니다. 다시 입력해주세요.")
                return
            }
            const addDate = new Date(new Date().setDate(new Date().getDate() + 280))
            if(new Date(this.params.expectedDt) > addDate){
                alert("출산예정일이 현재날짜보다 280일 초과되어 입력되었습니다. 다시입력해주세요.")
                return
            }
            "날짜가 범위를 벗어났습니다. 다시 입력해주세요."
            for (let i = 1; i <= this.count; i++) {
                if(!this.params[`baby${i}`]){
                    alert('태명을 입력해주세요.')
                    return
                }
            }
            if(this.mode == 'm' && this.familyList.length == 0){
                alert('등록된 정보가 없습니다.')
                location.reload()
                return
            }
            var year = this.params.expectedDt.getFullYear()
            var month = ('0' + (this.params.expectedDt.getMonth() + 1)).slice(-2)
            var day = ('0' + this.params.expectedDt.getDate()).slice(-2)

            this.params.expectedDt = year + '' + month + '' + day + '000000'

            let url = this.api.mypage.familyReg
            if(this.mode == 'm'){
                url = this.api.mypage.familyMod
                this.params.mfSn = this.familyList[0].mfSn
            }

            this.axios({
                method: "post",
                url: url,
                params: this.params
            })
            .then(res => {
                alert('저장되었습니다.')
                this.isActive = false
                this.getFamily()
            })
        },
        deleteFamily(){
            if (confirm('초기화하신 정보는 되돌릴 수 없습니다.\n초기화하시겠습니까?')) {
                this.axios({
                    method:"post",
                    url: this.api.mypage.familyDel, 
                    params: { 'mfSn' : this.familyList[0].mfSn}
                }).then(response => {
                    if(response.data.result.status){
                        this.getFamily();
                    }else{
                        alert('오류가 발생했습니다.')
                        location.reload()
                    }
                });
            }
        },
        getRsvList(){
            const currentDate = new Date();

            const year = currentDate.getFullYear();
            const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');

            const yyyymm = year + month;

            this.axios.get(this.api.babyNote.list, {
                params: {
                    'IN_SEL_MONTH': yyyymm
                }
            }).then(res => {
                const list = res.data

                if(list.length == 0){
                    return
                }

                const latest = list.reduce((max, current) => {
                    const currentDateMillis = parseInt(current.MED_DT.match(/\/Date\((\d+)\+?/)[1]);
                    const maxDateMillis = parseInt(max.MED_DT.match(/\/Date\((\d+)\+?/)[1]);

                    return currentDateMillis > maxDateMillis ? current : max;
                });

                // this.getRsvDetail(latest.PACT_ID)
                this.getRsvDetail(1016615940)
            })
        },
        getRsvDetail(id){
            this.axios.get(this.api.babyNote.detail, {
                params: {
                    'IN_PACT_ID': id
                }
            }).then(res => {
                this.rsvDetail = res.data
            })
        }
    },
    mounted() {
        this.getFamily()
        this.getRsvList()
    },
};
</script>
<style>

</style>